/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _, { isUndefined } from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField } from '@jutro/legacy/components';
import { Icon, DateField } from '@jutro/components';
import { Link } from '@jutro/router';
import { IntlContext, useTranslator } from '@jutro/locale';
import { accessibilityAddTableRow, focusNextElement, screenReaderAnnounce } from 'premier-capability-hooks';

import styles from './MovingTrafficViolationsComponent.module.scss';
import metadata from './MovingTrafficViolationsComponent.metadata.json5';
import ViolationCatSearchComponent from '../ViolationCategorySearch/ViolationCatSearchComponent';
import messages from './MovingTrafficViolationsComponent.messages';

function MovingTrafficViolationsComponent(props) {

    const {
        data: MovingTrafficViolationsVM,
        updateWizardData,
        submissionVM,
        MovingTrafficViolationsPath,
        id: movingTrafficViolationsId
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const intl = useContext(IntlContext);
    const translator = useTranslator();

    const addMovingTrafficViolations = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            MovingTrafficViolationsVM.value = MovingTrafficViolationsVM.value || []

            const { _xCenter, _dtoName } = MovingTrafficViolationsVM;

            const MovingTrafficViolationsObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            MovingTrafficViolationsObjVM.isValidationReq.value = true;
            MovingTrafficViolationsObjVM.numFie.value = MovingTrafficViolationsVM.value.length + 1
            MovingTrafficViolationsVM.pushElement(
                MovingTrafficViolationsObjVM
            );
            updateWizardData(submissionVM);
            
            accessibilityAddTableRow('Moving Traffic Violations');
            setTimeout(() => {
                focusNextElement(true,0, `${movingTrafficViolationsId }numFie`);
            }, 3000);
            
        },
        [submissionVM, updateWizardData, MovingTrafficViolationsVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const getFormattedDate = (date) => {
        if(!date){
            return ''
        }
        
       return intl.formatDate(new Date(
                        date.year,
                        date.month,
                        date.day
                    ), { year: 'numeric', month: 'short', day: 'numeric' });
    }

    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            const removedViolation = MovingTrafficViolationsVM.value[index];

            MovingTrafficViolationsVM.value.splice(index, 1);
            _.set(submissionVM.value, MovingTrafficViolationsPath, MovingTrafficViolationsVM.value);
            updateWizardData(submissionVM);
            screenReaderAnnounce(translator(messages.removedViolation, {vioDesc: removedViolation.desFie, vioDate: getFormattedDate(removedViolation.datofVioFie)}));
            focusNextElement(true,0, `addMovingTrafficViolationsButtonId`);
        }, [MovingTrafficViolationsVM.value, submissionVM, MovingTrafficViolationsPath, updateWizardData, translator, getFormattedDate]
    );

    const setSubmission = useCallback((submissionVM) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        updateWizardData(newSubmissionVM);
    });

    const checkOthFileDesc = (index) => {
        let val = true;

        if (!_.isUndefined(MovingTrafficViolationsVM.value[index].desFie)) {
            if (MovingTrafficViolationsVM.value[index].desFie === 'Other - Not on List') {
                val = false;
            }
        }

        return val;
    }

    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'numFie') {
                const value = item.numFie ? item.numFie : '';

                return (
                    <InputField
                        id={index + movingTrafficViolationsId+ path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.numFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }
            
            if (path === 'datofVioFie') {
                const value = item.datofVioFie ? item.datofVioFie : '';

                return (
                    <DateField
                        id={index + path}
                        value={value}
                        dataType='object'
                        path={path}
                        format="short"
                        layout="full-width"
                        showOptional={false}
                        onValueChange={(val, changedPath) => {
                            item.datofVioFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                    />
                );
            }

            if (path === 'vioCatFie') {
                const value = item.vioCatFie ? item.vioCatFie : '';
                let pathUpdated = `${MovingTrafficViolationsPath}.children[${index}]`;
                return (

                    <ViolationCatSearchComponent
                        id={index + path}
                        updateWizardData={updateWizardData}
                        index={index}
                        viewModelService={viewModelService}
                        submissionVM={submissionVM}
                        pathUpdated= {pathUpdated}
                        setSubmission={setSubmission}
                    >

                    </ViolationCatSearchComponent>
                    
                );
            }

            if (path === 'desFie') {
                const value = item.desFie ? item.desFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.desFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'ifOthFie') {
                const value = item.ifOthFie ? item.ifOthFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.ifOthFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        readOnly = {checkOthFileDesc(index)}
                    />
                );
            }
        }, [handleValueChange])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem, translator]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`MovingTrafficViolationsTable`]: {
            data: MovingTrafficViolationsVM.value,
        }, 
        [`addMovingTrafficViolationsButtonId`]: {
            'aria-label':  "Add Violation"
        }

    }), [MovingTrafficViolationsVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addMovingTrafficViolations,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            MovingTrafficViolationsVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [MovingTrafficViolationsVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={MovingTrafficViolationsVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

MovingTrafficViolationsComponent.propTypes = wizardProps;
export default withRouter(MovingTrafficViolationsComponent);
